import React from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import * as yup from 'yup'
import { Field, Formik } from 'formik'

import TextField from '../TextField'
import Button from '../Button'
import Checkbox from '../Checkbox'
import RoleSelect from '../RoleSelect'
import StateSelect from '../StateSelect'
import Form, { Group, Heading } from '../Form'
import { yupPhone, yupZip } from '../../utils/validations'

const CREATE_USER = gql`
  mutation createUser(
  $emailAddress: String!
  $firstName: String!
  $lastName: String!
  $phoneNumber: String!
  $line1: String!
  $line2: String!
  $city: String!
  $stateOrProvince: ID!
  $postalCode: String!
  $createLogin: Boolean!
  $password: String
  $role: Role!
  ) {
    createUser(
      emailAddress: $emailAddress
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      line1: $line1
      line2: $line2
      city: $city
      stateOrProvince: $stateOrProvince
      postalCode: $postalCode
      createLogin: $createLogin
      password: $password
      role: $role
    ) {
      id
    }
  }
`
yup.addMethod(yup.string, 'phone', yupPhone)
yup.addMethod(yup.string, 'zip', yupZip)

const validationSchema = yup.object().shape({
  emailAddress: yup.string().required('Email address is required').email('Email address is not valid'),
  firstName: yup.string().required('First name is required'),
  middleName: yup.string(),
  lastName: yup.string().required('Last name is required'),
  phoneNumber: yup.string().phone(),
  line1: yup.string().required('Address is required'),
  line2: yup.string(),
  city: yup.string().required('City is required'),
  stateOrProvince: yup.string().required('State is required'),
  postalCode: yup.string().required('Zip code is required').zip(),
  createLogin: yup.boolean(),
  password: yup.string().when('createLogin', {is: true, then: yup.string().required('Password is required').min(6, 'Password too short')}),
  role: yup.mixed().oneOf(['ADMIN', 'SALES', 'CLIENT']).required('Role is required')
})

const INITIAL_VALUES = {
  emailAddress: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  line1: '',
  line2: '',
  city: '',
  stateOrProvince: '',
  postalCode: '',
  createLogin: false,
  password: '',
  role: ''
}

const onSubmit = (values, {setSubmitting}, mutation) => {
  mutation({variables: values})
  setSubmitting(false)
}

const Create = ({onCompleted, onError}) =>
  <Mutation
    mutation={CREATE_USER}
    onCompleted={onCompleted}
    onError={onError}>
    {(mutation, {loading}) =>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => onSubmit(values, actions, mutation)}>
        {({isSubmitting, values}) =>
          <Form>
            <Heading>General</Heading>
            <Group>
              <Field component={TextField} name='firstName' required />
              <Field component={TextField} name='lastName' required />
            </Group>
            <Group>
              <Field component={TextField} name='emailAddress' required type='email' />
              <Field component={TextField} name='phoneNumber' phone />
            </Group>

            <Heading>Location</Heading>
            <Group>
              <Field component={TextField} name='line1' label='Address 1' required />
              <Field component={TextField} name='line2' label='Address 2' />
            </Group>
            <Group>
              <Field component={TextField} name='city' required />
              <Field component={StateSelect} name='stateOrProvince' label='State' required />
              <Field component={TextField} name='postalCode' label='Zip Code' required />
            </Group>

            <Heading>Purpose</Heading>
            <Field component={Checkbox} name='createLogin' label='Do they need to login?' />
            <Group>
              <Field component={TextField} name='password' required={values.createLogin} disabled={!values.createLogin} value={values.createLogin ? values.password : ''} hideError={!values.createLogin} />
              <Field component={RoleSelect} name='role' required />
            </Group>

            <Button mb={3} type='submit' fluid disabled={loading || isSubmitting}>Create New User</Button>
          </Form>
        }
      </Formik>
    }
  </Mutation>

export default Create


// WEBPACK FOOTER //
// ./src/components/Users/Create.js